<template>
  <a-modal v-model="open" title="新建匹配" width="700px" @ok="submit" @cancel="close">
    <div class="tableForm">
      <a-form-model ref="tableForm" :model="tableForm" labelAlign="right">
        <a-table :locale="{}" :columns="columns" :data-source="tableForm.dataSource" :pagination="false" bordered size="middle">
          <div slot="minScore" slot-scope="text, record, index">
            <a-form-model-item :prop="`dataSource[${index}].minScore`" label="" :rules="[{ required: true, message: '请填写内容', trigger: 'blur' }]">
              <a-input-number v-model="tableForm.dataSource[index].minScore" :precision="0" :min="50" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="maxScore" slot-scope="text, record, index">
            <a-form-model-item label="" :prop="`dataSource[${index}].maxScore`" :rules="[{ required: true, message: '请填写内容', trigger: 'blur' }]">
              <a-input-number v-model="tableForm.dataSource[index].maxScore" :precision="0" :min="50" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="level" slot-scope="text, record, index">
            <a-form-model-item label="" :prop="`dataSource[${index}].levelSign`" :rules="[{ required: true, message: '请选择关卡', trigger: 'change' }]">
              <a-select v-model="tableForm.dataSource[index].levelSign" :key="record.levelSign" :default-value="record.levelSign" placeholder="请选择关卡" style="width: 100%">
                <template v-for="item in levelList">
                  <a-select-option v-if="item.levelName != '练习关'" :value="item.levelSign" :text="item.levelName" :key="item.id">{{ item.levelName }}</a-select-option>
                </template>
              </a-select>
            </a-form-model-item>
          </div>
          <div slot="action" slot-scope="text, record, index">
            <a-icon v-if="index == tableForm.dataSource.length - 1" style="margin-right: 8px" type="plus-circle" @click="addItem(record)" />
            <a-icon style="margin-right: 8px" v-if="tableForm.dataSource.length > 1" type="minus-circle" @click="removeItem(record.id)" />
          </div>
        </a-table>
      </a-form-model>
    </div>
  </a-modal>
</template>
<script>
const columns = [
  {
    title: '最低分',
    dataIndex: 'minScore',
    align: 'center',
    key: 'minScore',
    scopedSlots: { customRender: 'minScore' },
  },
  {
    title: '最高分',
    dataIndex: 'maxScore',
    align: 'center',
    key: 'maxScore',
    scopedSlots: { customRender: 'maxScore' },
  },
  {
    title: '初始关卡设置',
    key: 'level',
    scopedSlots: { customRender: 'level' },
    align: 'center',
  },
  {
    title: '',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]
export default {
  name: 'AddLeveMdoal',
  props: {
    levelList: {
      type: Array,
      default: () => [],
    },
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
      tableForm: {
        dataSource: [
          {
            minScore: undefined,
            maxScore: undefined,
            levelSign: undefined,
            id: +new Date(),
          },
        ],
      },
      columns,
    }
  },
  methods: {
    showMdoal() {
      return new Promise((res, rej) => {
        this._res = res
        this._rej = rej
        this.open = true
        console.log(document.querySelector('.beauty-scroll'))
        document.querySelector('#popContainer').style.setProperty('overflow-y','hidden')
      })
    },
    close() {
      this._rej()
      this.open = false
      this.$refs['tableForm'].resetFields()
      this.tableForm.dataSource = [
        {
          minScore: undefined,
          maxScore: undefined,
          levelSign: undefined,
          id: +new Date(),
        },
      ]
      document.querySelector('#popContainer').style.setProperty('overflow-y','scroll')
    },
    repeatScoreValidator() {
      const tableSet = new Set()
      const setScore = (min, max) => {
        for (let i = min; i <= max; i++) {
          if (tableSet.has(i)) {
            return false
          } else {
            tableSet.add(i)
          }
        }
        return true
      }
      const data = [].concat(this.tableForm.dataSource, this.dataList)
      return data.some((item) => {
        const isRepeat = setScore(+item.minScore, +item.maxScore)
        return !isRepeat
      })
    },
    submit() {
      this.$refs['tableForm'].validate(async (valid) => {
        if (valid) {
          if (this.repeatScoreValidator()) {
            return this.$message.error('分数范围重复')
          }
          this._res(JSON.parse(JSON.stringify(this.tableForm.dataSource)))
          this.close()
        }
      })
    },
    addItem() {
      this.tableForm.dataSource.push({
        minScore: undefined,
        maxScore: undefined,
        level: undefined,
        id: +new Date(),
      })
    },
    removeItem(id) {
      this.tableForm.dataSource = this.tableForm.dataSource.filter((v) => v.id != id)
    },
    getRecord(item, record) {},
  },
}
</script>
<style lang="less" scoped>
.tableForm {
  ::v-deep .ant-form-item {
    margin-bottom: 0px;
  }
}
</style>
